// src/utils/dateUtils.js

function getToday() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getLast30Days() {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - 30);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    start: formatDate(pastDate),
    end: formatDate(today),
  };
}

function getLastYear() {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setFullYear(today.getFullYear() - 1);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    start: formatDate(pastDate),
    end: formatDate(today),
  };
}

function dateFormatDmy(tanggal) {
  let date = new Date(tanggal);
  let yy = date.getFullYear().toString().slice(-2);
  let mm = String(date.getMonth() + 1).padStart(2, "0");
  let dd = String(date.getDate()).padStart(2, "0");
  return `${dd}-${mm}-${yy}`;
}

function getThisYearRange() {
  const today = new Date();

  // Tanggal 1 Januari tahun ini
  const startOfThisYear = new Date(today.getFullYear(), 0, 1);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return {
    start: formatDate(startOfThisYear), // 1 Januari tahun ini
    end: formatDate(today), // Hari ini
  };
}

export {
  getToday,
  getLast30Days,
  dateFormatDmy,
  getLastYear,
  getThisYearRange,
};
